/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './QuickPromo.scss';

import cx from 'classnames';

import { Button } from 'sarsaparilla';

type QuickPromoBaseProps = {
    label: string;
    labelType?:
        'camping' | 'tickets' | 'permits' | 'passes' | 'lotteries' | 'hunting' | 'venues';
    imagePath: string;
    gaTrackingId?: string;
};

type ButtonPromoProps = {
    onClick: () => void;
};

type LinkPromoProps = {
    href: string;
};

type QuickPromoProps = QuickPromoBaseProps & (ButtonPromoProps | LinkPromoProps);

export function QuickPromo(props: QuickPromoProps) {
    const { label, labelType = 'camping', imagePath, gaTrackingId } = props;

    const isLink = 'href' in props;
    const isButton = 'onClick' in props;

    const handleClick = (
        event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>
    ) => {
        event.preventDefault();

        // Remove local storage search session to avoid stacking of search options from previous
        // searches. This can be removed once we finally get rid of the localStorage mess
        try {
            window.localStorage.removeItem('r1s_search_session');
        } catch (error) {
            // do nothing
        }

        if (isLink) {
            window.location.assign(props.href);
        } else {
            props.onClick?.();
        }
    };

    return (
        <Button
            isUnstyled
            href={isLink ? props.href : undefined}
            onClick={handleClick}
            className="nav--quick-promo"
            gaTrackingId={gaTrackingId}
            role={isButton ? 'link' : undefined}
        >
            {/* Note: Image is presentation only and should not contribute to link accessibility label */}
            <img src={imagePath} alt="" className="image" />
            <span className="gradient-overlay" />
            <span className="label-wrap">
                <span className={cx('label', labelType)}>{label}</span>
            </span>
        </Button>
    );
}
